// ─────────────────────────────────────────────
//  useLocations — real-time location config for a facility.
//
//  Locations live on the facility document (facility.locations). This listens
//  to that doc and resolves the list (falling back to defaults when unset), so
//  the board, room setup, and facility tab all stay in sync.
// ─────────────────────────────────────────────
import { useEffect, useState } from "react";
import { listenToFacility } from "../firebase/firestore";
import { resolveLocations, activeLocations } from "../domain/locations";

export function useLocations(facilityId) {
  const [locations, setLocations] = useState(() => resolveLocations());
  const [loading, setLoading]     = useState(true);

  useEffect(() => {
    if (!facilityId) { setLoading(false); return; }
    const unsub = listenToFacility(
      facilityId,
      (snap) => {
        setLocations(resolveLocations(snap.data()?.locations));
        setLoading(false);
      },
      () => { setLocations(resolveLocations()); setLoading(false); }
    );
    return unsub;
  }, [facilityId]);

  return { locations, active: activeLocations(locations), loading };
}
